// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"8ae7b9cf","512":"4b563b98","740":"08888952","820":"3ef46137","969":"de61d78d"}[chunkId] + ".chunk.js";
};